module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row r_m",
    attrs: {
      "id": "rm"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "x_panel tile "
  }, [_c('div', {
    staticClass: "x_content pform"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-8",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('hydroware-inline-input', {
    staticClass: "row hydroware-editNoEdit",
    attrs: {
      "disabled": _vm.$hydrowareSecurityJS.disableDataEntry_A('managetemplates', _vm.isAddingOrEditing),
      "labeltext": "Template Name"
    },
    model: {
      value: (_vm.templateModel.Name),
      callback: function($$v) {
        _vm.$set(_vm.templateModel, "Name", $$v)
      },
      expression: "templateModel.Name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('el-button', {
    staticStyle: {
      "float": "right",
      "padding-right": "15px",
      "margin-bottom": "10px",
      "padding-left": "15px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showListOfTemplates()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left",
    staticStyle: {
      "font-size": "16px",
      "color": "white"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("View Template")])])], 1)]), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "id": "readings_maintenance_tabs",
      "type": "card",
      "editable": ""
    },
    on: {
      "tab-click": _vm.tabClick,
      "edit": _vm.handleTabsEdit
    },
    model: {
      value: (_vm.chosenTabNumber),
      callback: function($$v) {
        _vm.chosenTabNumber = $$v
      },
      expression: "chosenTabNumber"
    }
  }, _vm._l((_vm.tabModels), function(item, index) {
    return _c('el-tab-pane', {
      key: item.name,
      attrs: {
        "label": item.title,
        "name": item.name
      }
    }, [_c('div', {
      staticClass: "col-md-4 col-xs-12",
      staticStyle: {
        "padding": "5px"
      }
    }, [_c('hydroware-checkbox-group', {
      attrs: {
        "title": "Readings",
        "choices": _vm.displayedReadings,
        "disableChoices": _vm.$hydrowareSecurityJS.disableDataEntry_A('managetemplates', _vm.isAddingOrEditing),
        "varForDisplayedValue": "Name",
        "varForKey": "Id",
        "varForLabel": "Id"
      },
      on: {
        "change": function($event) {
          return _vm.readingAppend(index)
        }
      },
      model: {
        value: (_vm.chosenReadingIds),
        callback: function($$v) {
          _vm.chosenReadingIds = $$v
        },
        expression: "chosenReadingIds"
      }
    }, [_c('span', {
      attrs: {
        "slot": "after_header_title"
      },
      slot: "after_header_title"
    }, [_c('el-checkbox', {
      staticClass: "hydroware-checkbox hydroware-inline",
      on: {
        "change": _vm.ToggleDisplayedReadings
      },
      model: {
        value: (_vm.showOnlyChosenReadings),
        callback: function($$v) {
          _vm.showOnlyChosenReadings = $$v
        },
        expression: "showOnlyChosenReadings"
      }
    }, [_vm._v("\n                        Show only chosen\n                      ")]), _vm._v("\n                         \n                      "), _c('el-button', {
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.showrange()
        }
      }
    }, [_vm._v("\n                        Range Values\n                      ")])], 1)])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 col-xs-12",
      staticStyle: {
        "padding": "5px"
      }
    }, [_c('hydroware-checkbox-group', {
      attrs: {
        "disableChoices": _vm.$hydrowareSecurityJS.disableDataEntry_A('managetemplates', _vm.isAddingOrEditing),
        "title": "Maintenance",
        "choices": _vm.displayedMaintenance,
        "varForDisplayedValue": "Name",
        "varForKey": "Id",
        "varForLabel": "Id"
      },
      on: {
        "change": function($event) {
          return _vm.maintenanceAppend(index)
        }
      },
      model: {
        value: (_vm.chosenMaintenanceIds),
        callback: function($$v) {
          _vm.chosenMaintenanceIds = $$v
        },
        expression: "chosenMaintenanceIds"
      }
    }, [_c('span', {
      attrs: {
        "slot": "after_header_title"
      },
      slot: "after_header_title"
    }, [_c('el-checkbox', {
      staticClass: "hydroware-checkbox hydroware-inline",
      on: {
        "change": _vm.ToggleDisplayedMaintenance
      },
      model: {
        value: (_vm.showOnlyChosenMaintenance),
        callback: function($$v) {
          _vm.showOnlyChosenMaintenance = $$v
        },
        expression: "showOnlyChosenMaintenance"
      }
    }, [_vm._v("\n                        Show only chosen\n                      ")])], 1)])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 col-xs-12",
      staticStyle: {
        "padding": "5px"
      }
    }, [_c('hydroware-checkbox-group', {
      attrs: {
        "disableChoices": _vm.$hydrowareSecurityJS.disableDataEntry_A('managetemplates', _vm.isAddingOrEditing),
        "title": "Tasks",
        "choices": _vm.displayedTasks,
        "varForDisplayedValue": "Name",
        "varForKey": "Id",
        "varForLabel": "Id"
      },
      on: {
        "change": function($event) {
          return _vm.taskAppend(index)
        }
      },
      model: {
        value: (_vm.chosenTaskIds),
        callback: function($$v) {
          _vm.chosenTaskIds = $$v
        },
        expression: "chosenTaskIds"
      }
    }, [_c('span', {
      attrs: {
        "slot": "after_header_title"
      },
      slot: "after_header_title"
    }, [_c('el-checkbox', {
      staticClass: "hydroware-checkbox hydroware-inline",
      on: {
        "change": _vm.ToggleDisplayedTasks
      },
      model: {
        value: (_vm.showOnlyChosenTasks),
        callback: function($$v) {
          _vm.showOnlyChosenTasks = $$v
        },
        expression: "showOnlyChosenTasks"
      }
    }, [_vm._v("\n                        Show only chosen\n                      ")])], 1)])], 1)])
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12 col-sm-12",
    staticStyle: {
      "margin-left": "-20px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(!_vm.isediting && _vm.$hydrowareSecurityJS.canAdd_A('managetemplates')) ? _c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "background-color": "#4DB3FF",
      "border-color": "#4DB3FF",
      "color": "white",
      "width": "125px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.templateModel.Name
    },
    on: {
      "click": _vm.addTemplate
    }
  }, [_vm._v("\n            Save\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isediting && _vm.$hydrowareSecurityJS.canEdit_A('managetemplates')) ? _c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "background-color": "#4DB3FF",
      "border-color": "#4DB3FF",
      "color": "white",
      "width": "125px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.templateModel.Name
    },
    on: {
      "click": function($event) {
        return _vm.updateTemplate('addCompliance')
      }
    }
  }, [_vm._v("\n            Update\n        ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "PoolSelectModel",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog ",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "5px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [(_vm.poolListForSelection.length > 0) ? _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select Pool",
      "value-key": "PoolName"
    },
    model: {
      value: (_vm.pool),
      callback: function($$v) {
        _vm.pool = $$v
      },
      expression: "pool"
    }
  }, _vm._l((_vm.poolListForSelection), function(item) {
    return _c('el-option', {
      key: item.PoolId,
      attrs: {
        "label": item.PoolName,
        "value": item,
        "disabled": item.disabled
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.poolListForSelection.length < 1) ? _c('div', [_c('h3', [_vm._v("All pools have been chosen")])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12 col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "color": "gray",
      "width": "125px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                Cancel\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "background-color": "#4DB3FF",
      "border-color": "#4DB3FF",
      "color": "white",
      "width": "125px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.pool,
      "id": "addTabs"
    }
  }, [_vm._v("\n                Select\n              ")])])])])])]), _vm._v(" "), _c('div', {
    ref: "ViewRangeValuemodel",
    staticClass: "modal fade",
    staticStyle: {
      "text-align": "center",
      "height": "100%"
    },
    attrs: {
      "id": "ViewRangeValuemodel",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    staticStyle: {
      "display": "inline-block",
      "text-align": "left",
      "vertical-align": "middle",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "5px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "max-height": "calc(100vh - 200px)",
      "overflow-y": "hidden"
    }
  }, [_c('el-table', {
    staticStyle: {
      "overflow-y": "auto",
      "height": "100%",
      "max-height": "calc(100vh - 275px)"
    },
    attrs: {
      "data": _vm.rangevalues,
      "fit": true,
      "stripe": true,
      "border": true,
      "show-header": true
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Reading",
      "width": 170
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.Name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Low",
      "width": 80,
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.Low))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Ideal Low",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.IdealLow))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Ideal High",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.IdealHigh))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "High",
      "width": 80,
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.High))])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _vm._m(2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header modelheadercurved"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "text-align": "center",
      "color": "white"
    },
    attrs: {
      "id": "myModalLabel"
    }
  }, [_c('h3', [_vm._v("Select Pool")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "background-color": "#6DC8F4",
      "border-radius": "inherit"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "myModalLabel"
    }
  }, [_c('h3', [_vm._v("Range Values")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "color": "gray",
      "width": "125px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n\t\t\t\t\t    Close\n\t\t\t\t    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2eefac56"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReadingsMaintenance/readings_maintenance.vue
// module id = 794
// module chunks = 1